const CELEX_DOCUMENT_ID_PATTERN = /^\d{5}[A-Z]\d{4,}(?:-\d{8})?$/

export function parseCelexForEurLex(rawValue: string): string | null {
  if (!rawValue) {
    return null
  }

  const candidate = rawValue
    .split('__')
    .map((part) => part.trim().toUpperCase())
    .find((part) => part.length > 0)

  if (!candidate || !CELEX_DOCUMENT_ID_PATTERN.test(candidate)) {
    return null
  }

  return candidate
}

export function buildEurLexHtmlUrlFromCelex(celex: string): string {
  return `https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:${encodeURIComponent(celex)}`
}

export function resolveEurLexCelexForScopeTierItem(item: {
  celex: string
  consolidatedCelex?: string | null
}): string | null {
  const consolidated = item.consolidatedCelex
    ? parseCelexForEurLex(item.consolidatedCelex)
    : null
  if (consolidated) {
    return consolidated
  }
  return parseCelexForEurLex(item.celex)
}

export function collectEurLexUrlsForCelexItems(
  items: Array<{ celex: string; consolidatedCelex?: string | null }>,
  limit: number
): { urls: string[]; skipped: number } {
  const urls: string[] = []
  let skipped = 0
  for (const item of items) {
    if (urls.length >= limit) {
      break
    }
    const celex = resolveEurLexCelexForScopeTierItem(item)
    if (!celex) {
      skipped += 1
      continue
    }
    urls.push(buildEurLexHtmlUrlFromCelex(celex))
  }
  return { urls, skipped }
}

export function openEurLexTabsForCelexItems(
  items: Array<{ celex: string }>,
  limit: number,
  openFn: (url: string, target: string, features: string) => Window | null = window.open.bind(window)
): { opened: number; skipped: number; blocked: number } {
  const { urls, skipped } = collectEurLexUrlsForCelexItems(items, limit)
  let opened = 0
  let blocked = 0

  for (const url of urls) {
    const popup = openFn(url, '_blank', 'noopener,noreferrer')
    if (popup) {
      opened += 1
    } else {
      blocked += 1
    }
  }

  return { opened, skipped, blocked }
}
